import React from "react";
import { Box, Typography } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import { useTranslation } from "react-i18next";

function EmptyTimesView({ onAddTime }) {
  const { t } = useTranslation();
  return (
    <Box textAlign="center" py={5}>
      <AccessTimeIcon
        sx={{ width: "80px", height: "80px", color: "grey.400" }}
      />
      <Typography variant="h6" sx={{ mt: 2 }}>
        {t("trajectories.wizard.emptyTimesView.title")}
      </Typography>
      <Typography variant="body1" color="HighlightText" sx={{ mt: 1 }}>
        {t("trajectories.wizard.emptyTimesView.description")}
      </Typography>
      <MDButton
        variant="contained"
        color="info"
        size="medium"
        sx={{ mt: 3 }}
        onClick={onAddTime}
      >
        <Icon>add</Icon>&nbsp;{t("trajectories.wizard.emptyTimesView.buttonLabel")}
      </MDButton>
    </Box>
  );
}

export default EmptyTimesView;
